const safeDecodeUriComponent = (value) => {
  try {
    return decodeURIComponent(String(value || ""));
  } catch (_error) {
    return String(value || "");
  }
};

const normalizePathSegments = (pathname = "") => {
  return String(pathname)
    .split("/")
    .map((segment) => {
      if (!segment) return "";
      return encodeURIComponent(safeDecodeUriComponent(segment));
    })
    .join("/");
};

export const normalizeMediaUrl = (input) => {
  if (!input) return "";

  const raw = String(input).trim();
  if (!raw) return "";

  if (/^https?:\/\//i.test(raw)) {
    try {
      const parsed = new URL(raw);
      parsed.pathname = normalizePathSegments(parsed.pathname || "");
      return parsed.toString();
    } catch (_error) {
      return raw;
    }
  }

  const hashIndex = raw.indexOf("#");
  const urlWithoutHash = hashIndex >= 0 ? raw.slice(0, hashIndex) : raw;
  const hash = hashIndex >= 0 ? raw.slice(hashIndex) : "";

  const queryIndex = urlWithoutHash.indexOf("?");
  const pathname = queryIndex >= 0 ? urlWithoutHash.slice(0, queryIndex) : urlWithoutHash;
  const query = queryIndex >= 0 ? urlWithoutHash.slice(queryIndex) : "";

  return `${normalizePathSegments(pathname)}${query}${hash}`;
};

export const extractMediaFilename = (mediaUrl) => {
  if (!mediaUrl) return "";

  const raw = String(mediaUrl);

  if (/^https?:\/\//i.test(raw)) {
    try {
      const parsed = new URL(raw);
      const segments = String(parsed.pathname || "").split("/").filter(Boolean);
      return safeDecodeUriComponent(segments[segments.length - 1] || "");
    } catch (_error) {
      return "";
    }
  }

  const cleaned = raw.split("?")[0].split("#")[0];
  const parts = cleaned.split("/").filter(Boolean);
  return safeDecodeUriComponent(parts[parts.length - 1] || "");
};

export { safeDecodeUriComponent };